
export const contactTemplate = (contacts, stimulus_controller) => {
  
  return contacts.map((contact, index) =>
    `<div class="w-full d-flex justify-content-between align-items-center pb-2">
      <span role="alert" aria-label="${contact.name} is a service user and will join by ${contact.joining_preference}">
        ${((contact.joining_preference == 'scheduled_dialout') ? '<i class="fas fa-clock me-2"></i>':'')} 
        ${((contact.joining_preference == 'facilitator_dialout') ? '<i class="fas fa-user-clock me-2"></i>':'')}
        ${((contact.joining_preference == null && stimulus_controller.includes('scheduled')) ? '<i class="fas fa-user-clock me-2"></i>':'')}
        ${((contact.joining_preference == 'dial_in') ? '<i class="fas fa-phone-alt me-2"></i>':'')}
        ${((contact.joining_preference == 'video') ? '<i class="fas fa-video me-2"></i>':'')}   
        ${contact.name}
      </span>
  
      <span class="d-flex align-items-center">
        ${((contact.short_link) ? `<button aria-live="off" aria-label="Copy ${contact.name}'s short link to clipboard" class="btnclipboard btn btn-sm btn-square btn-neutral me-2" data-clipboard-text="${contact.short_link}"><i class="fas fa-link"></i></button>` : '')}

        <button aria-live="off" aria-label="Send join email to ${contact.name}" data-action="click->${stimulus_controller}#sendEmail" data-guest-key="${index}" data-guest-type="contact" class="btn btn-sm btn-neutral btn-square me-2">
          <i class="fas fa-envelope"></i>
        </button>

        <button aria-live="off" aria-label="Remove ${contact.name} as a service user from this session" data-action="click->${stimulus_controller}#removeContact" data-guest-key="${index}" class="btn btn-sm btn-neutral btn-square">
          <i class="fas fa-times"></i>
        </button>
      </span>
    </div>`
    ).join('');
  }


export const facilitatorTemplate = (facilitators, stimulus_controller) => {
  return facilitators.map((facilitator, index) =>
  `<div class="w-full d-flex justify-content-between align-items-center pb-2">
    <span role="alert" aria-label="${facilitator.name} is a facilitator and will join by ${facilitator.joining_preference}">
      ${((facilitator.joining_preference == 'scheduled_dialout') ? '<i aria-hidden="true"  class="fas fa-clock me-2"></i>':'')} 
      ${((facilitator.joining_preference == 'online') ? '<i aria-hidden="true"  class="fas fa-tv me-2"></i>':'')}  
      ${facilitator.name} 
    </span>

    <span class="d-flex align-items-center">
      ${((facilitator.short_link) ? `<button aria-live="off" aria-label="Copy ${facilitator.name}'s short link to clipboard" class="btnclipboard btn btn-sm btn-square btn-neutral me-2" data-clipboard-text="${facilitator.short_link}"><i class="fas fa-link"></i></button>` : '')}

      <button aria-live="off" aria-label="Send join email to ${facilitator.name}" data-action="click->${stimulus_controller}#sendEmail" data-guest-key="${index}" data-guest-type="facilitator" class="btn btn-sm btn-neutral btn-square me-2">
        <i class="fas fa-envelope"></i>
      </button>

      <button aria-live="off" aria-label="Remove ${facilitator.name} as a facilitator for this session" data-action="click->${stimulus_controller}#removeFacilitator" data-guest-key="${index}" class="btn btn-sm btn-neutral btn-square">
        <i class="fas fa-times"></i>
      </button>
    </span>
  </div>`
  ).join('');
}

export const callerTemplate = (callers, stimulus_controller) => {
  return callers.map((caller, index) =>
  `<span class="w-full btn btn-md d-inline-flex btn-neutral mb-2 me-2 justify-content-between">
  <span role="alert" aria-label="${caller.name} is the caller">
    ${caller.name} (Caller)
  </span>
    <a aria-live="off" aria-label="Remove ${caller.name} as the caller" data-action="click->${stimulus_controller}#removeCaller" data-guest-key="${index}" role="button">
      <i class="fas fa-times"></i>
    </a>
  </span>`
  ).join('');
}

export const recipientTemplate = (recipients, stimulus_controller) => {
  return recipients.map((recipient, index) =>
  `<span class="w-full btn btn-md d-inline-flex btn-neutral mb-2 me-2 justify-content-between">
  <span role="alert" aria-label="${recipient.name} is the recipient">
    ${recipient.name} (Recipient)
  </span>
    <a aria-live="off" aria-label="Remove ${recipient.name} as the recipient" data-action="click->${stimulus_controller}#removeCaller" data-guest-key="${index}" role="button">
      <i class="fas fa-times"></i>
    </a>
  </span>`
  ).join('');
}